"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const react_1 = __importDefault(require("react"));
const Person_1 = __importDefault(require("@material-ui/icons/Person"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const registerUser_1 = __importStar(require("../actions/users/registerUser"));
const NameInput_1 = __importDefault(require("./shared/NameInput"));
const useStyles = makeStyles_1.default((theme) => ({
    paper: {
        color: theme.colors.loginRegister.textColor,
        backgroundColor: theme.colors.loginRegister.backgroundColor,
        textAlign: "center",
        padding: 20
    },
    icon: {
        width: 80,
        height: 80,
        alignSelf: "center"
    },
    button: {
        color: theme.colors.loginRegister.buttonTextColor,
        backgroundColor: theme.colors.loginRegister.buttonBackgroundColor,
        "&:hover": {
            backgroundColor: theme.colors.loginRegister.buttonBackgroundColor
        }
    },
    nameInput: {
        margin: "auto",
        maxWidth: 400,
        marginTop: 30
    },
    errorText: {
        minHeight: 20,
        maxWidth: 400,
        marginTop: 20,
        color: "red",
        alignSelf: "center"
    },
    errorContainer: {
        display: "flex",
        justifyContent: "center"
    }
}));
function RegisterUser() {
    const dispatch = react_redux_1.useDispatch();
    const classes = useStyles();
    const [errorText, setErrorText] = react_1.default.useState("");
    function handleSubmit(text) {
        if (text && text.length > 2) {
            setErrorText("");
            const registerUserAsync = () => dispatch(registerUser_1.default(text));
            registerUserAsync().then((outcome) => {
                switch (outcome.type) {
                    case registerUser_1.REGISTER_USER_SUCCEEDED:
                        setErrorText("");
                        break;
                    case registerUser_1.REGISTER_USER_FAILED_USER_EXISTS:
                        setErrorText("You already have a name");
                        break;
                    case registerUser_1.REGISTER_USER_FAILED_USERNAME_EXISTS:
                        setErrorText("A user already exists with this username - please try another username");
                        break;
                    case registerUser_1.REGISTER_USER_LIMIT_REACHED:
                        setErrorText(`The number of users of this demo version of OpenChat has been limited to ${outcome.payload} and this limit has been reached. Check back soon for the full release!`);
                        break;
                }
            });
        }
    }
    return (react_1.default.createElement(Paper_1.default, { className: classes.paper },
        react_1.default.createElement(Person_1.default, { className: classes.icon }),
        react_1.default.createElement("h1", null, "Register user"),
        react_1.default.createElement(NameInput_1.default, { onSubmit: handleSubmit, placeholderText: "Enter username", minLength: 3, maxLength: 25, className: classes.nameInput }),
        react_1.default.createElement("div", { className: classes.errorContainer },
            react_1.default.createElement(Typography_1.default, { component: "div", variant: "body1", className: classes.errorText }, errorText))));
}
exports.default = RegisterUser;
